import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class {
  constructor(){
    this.header = document.querySelector('.c-header')
    this.sections = gsap.utils.toArray('[data-header-invert]')
    this.create()
  }

  create() {

    let offset = this.header.clientHeight

    this.sections.forEach(section => {
     
      ScrollTrigger.create({
        trigger: section,
        // start: 'top top-=-80',
        // end: 'bottom top-=-80',
        start: `top top-=-${offset}`,
        end: `bottom top-=-${offset}`,
        toggleClass: {
          targets: '.c-header',
          className: 'c-header--is-inverted'
        },
        // markers: true
      })
     
    })
  }

  destroy() {

    ScrollTrigger.getAll().forEach(st => st.kill())
    
  }

}



